import { makeStyles } from '@material-ui/core';

export const styles = makeStyles((theme) => ({
    package: {
        backgroundColor: '#464652',
        boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.25)',
        borderRadius: '15px',
        margin: 10,
        display: 'flex',
        width: 390,
        flexDirection: 'column',
        overflow: 'hidden',
        height: 330,
    },
    packageHeadWrapper: {
        backgroundColor: '#464652',
        height: 96,
        color: 'white',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    packageAbout: {
        color: 'white',
    },
    packageName: {
        fontWeight: 700,
        display: 'flex',
        flexDirection: 'column',
    },
    packageContainer: {
        width: 260,
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    pricePerUser: {
        position: 'absolute',
        display: 'flex',
        width: '84px',
        height: '20px',
        top: '-30px',
        background: theme.palette.primary.main,
        borderRadius: '10px',
        fontWeight: 600,
        fontSize: '10px',
        justifyContent: 'center',
        color: 'white',
        alignItems: 'center',
    },
    perYear: {
        marginLeft: '24px',
    },
    priceContainer: {
    },
    dollarSign: {
        alignSelf: 'flex-start',
    },
    price: {
        width: 'fit-content',
        marginLeft: 'auto',
        marginRight: 'auto',
        fontWeight: 700,
        fontSize: '50px',
    },
    features: {
        height: '147px',
        display: 'flex',
        flexDirection: 'column',
        marginTop: '36px',
        marginBottom: '36px',
    },
    featureContainer: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row' as 'row',
        marginBottom: '17px',
    },
    checkMark: {
        fontWeight: 'bold',
        fontSize: '1rem',
        alignSelf: 'center',
        marginRight: '10.5px',
    },
    chooseButton: {
        display: 'flex',
        backgroundColor: theme.palette.primary.main,
        marginTop: '40px',
        marginLeft: 'auto',
        marginRight: 'auto',
        color: 'white',
        width: 'fit-content',
        paddingLeft: '20px',
        paddingRight: '20px',
        borderRadius: '8px',
        '&:hover': {
            backgroundColor: '#e8101a',
        },
    },
}));
